import Inventory, { InventoryProduct } from './Inventory';
import { LOG_TYPE } from './Log';
import { PageType } from './PageData';

export type SESSIONSTATE = 'INIT' | 'IDLE' | 'ACTIVE';

export type SESSIONDATA = { [key: string]: any };

export enum RECEIVER_ACTIONS {
  CHANGE_PAGE = 'CHANGE_PAGE',
  SET_DATA = 'SET_DATA',
}

export enum SENDER_ACTIONS {
  VEND = 'VEND',
  SEND_QR_DATA = 'SEND_QR_DATA',
  CONFIGURE_CHANNELS = 'CONFIGURE_CHANNELS',
  POST_INVENTORY = 'POST_INVENTORY',
  POST_LOG = 'POST_LOG',
  GET_INVENTORY_ONLINE = 'GET_INVENTORY_ONLINE',
  GET_PRODUCTS_ONLINE = 'GET_PRODUCTS_ONLINE',
  REINITIALIZE_MACHINE = 'REINITIALIZE_MACHINE',
  SESSION_RESET = 'SESSION_RESET',
  SESSION_START = 'SESSION_START',
  RESET_MACHINE = 'RESET_MACHINE',
  GET_MACHINE_STATUS = 'GET_MACHINE_STATUS',
  CLOSE_APPLICATION = 'CLOSE_APPLICATION',
}

export type COM_DATA = {
  deviceId: string;
  products: InventoryProduct[] | null;
  inventory: Inventory | null;
  experienceId: string | null;
  isChannelsConfigured: boolean;
  isExperienceConfigured: boolean;
};

export type PAGE_CHANGE_REQUEST = {
  page: PageType;
  message?: string;
};

declare global {
  interface Window {
    RECEIVER: (action: { type: RECEIVER_ACTIONS; payload: string | COM_DATA | PAGE_CHANGE_REQUEST }) => void;
    SENDER: (action: { type: SENDER_ACTIONS; payload: unknown }) => void;
    LOGGER: (action: { type: LOG_TYPE; payload: string }) => void;
    DATA: COM_DATA;
    MESSAGE: string;
    chrome: { webview: { postMessage: (action: { type: SENDER_ACTIONS; payload: unknown }) => void } };
  }
}
